








































import { defineComponent, computed, watch } from '@vue/composition-api';
import theme from '@zk/theme/lib/variables.scss';
import { useInstance } from 'common-module/src/util/useInstance';
import { useGetter, useVuex } from 'common-module/src/util/useVuex';
import { useI18n } from 'common-module/src/util/useI18n';
import { isOverseasVersion } from 'common-module/src/util';
import { isNil } from 'lodash';
import * as permission from 'common-module/src/config/permission';

interface creditsRightItem {
  accountRight: boolean; // 是否个人账户
  remainingNum: number;
  rightType: 'string';
  totalNum: number;
  usedNum: number;
}

export default defineComponent({
  name: 'AIUsage',
  bemNS: theme.bemNS,
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  setup(props, ctx) {
    const instance = useInstance();
    const vuex = useVuex();
    const { t: $t } = useI18n();

    // 产品权益
    const productRights = computed(() => useGetter('user/userProductRights'));
    const AICredit = computed(() => useGetter('user/getAICredit'));
    const isAWSUserMark = computed(() => useGetter('isAWSUserMark'));
    const hasUpgradePermission = computed(() => useGetter('user/checkAccessPermission')(permission.upgrade));

    const privateRight = computed(() => (AICredit.value || []).find((i: creditsRightItem) => i.accountRight));
    const teamRight = computed(() => (AICredit.value || []).find((i: creditsRightItem) => !i.accountRight));

    const creditsConfig = computed(() => {
      return [
        {
          label: $t('AIRight.menu.private'),
          key: privateRight.value?.rightType,
          total: privateRight.value?.totalNum || 0,
          used: privateRight.value?.usedNum || 0,
          remaining: privateRight.value?.remainingNum || 0,
          showBtn: false,
          fn: null
        },
        {
          label: $t('AIRight.menu.team'),
          key: teamRight.value?.rightType,
          total: teamRight.value?.totalNum || 0,
          used: teamRight.value?.usedNum || 0,
          remaining: teamRight.value?.remainingNum || 0,
          showBtn: isOverseasVersion ? hasUpgradePermission.value && !isAWSUserMark.value : false,
          btnText: buyCreditsText.value,
          fn: onBuyCredits
        }
      ];
    });

    // 是否付费用户
    const isPaidUser = computed(() => Number(productRights.value?.buyType) >= 1);

    const onBuyCredits = () => {
      // TODO: 海外版才能购买ai credit
      isPaidUser.value && isOverseasVersion
        ? instance.eventBus.$emit('global:openAIRight', { from: 'menu' })
        : instance.eventBus.$emit('global:openUpgradeDialog');
      ctx.emit('hide');
    };
      // TODO: 海外版才能购买ai credit
    const buyCreditsText = computed(() => isPaidUser.value && isOverseasVersion ? $t('AIRight.buyCredits') : $t('button.Upgrade'));

    // 监听弹窗显示时，刷新产品权益
    watch(
      () => props.visible,
      (val) => {
        val && vuex.dispatch('user/refreshProductRights', { force: true });
      },
      { immediate: true }
    );

    const getPercentage = (totalNum:number = 0, usedNum:number = 0) => {
      if (isNil(totalNum) || isNil(usedNum)) {
        return 0;
      }
      const percentage = (Number(usedNum) / Number(totalNum)) * 100 || 0;
      return Math.round(percentage * 100) / 100;
    };

    return {
      productRights,
      privateRight,
      teamRight,
      AICredit,
      isPaidUser,
      buyCreditsText,
      creditsConfig,
      onBuyCredits,
      getPercentage
    };
  }
});
